/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-28T14:19:44.661
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialCollectionCoupont,
	listFinancialCollectionCoupontInit,
	listFinancialCollectionCoupontByAuthorizations,
	deleteFinancialCollectionCoupont
} from '@api/financial/FinancialCollectionCoupont';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialCollectionCoupont({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialCollectionCoupont(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialCollectionCoupontByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialCollectionCoupontByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialCollectionCoupontInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialCollectionCoupontInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialCollectionCoupont({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialCollectionCoupont({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
